import { baseURL, get, post, put, remove, upload } from './config'

export const isRefresh = true
export const uploadURL = baseURL + '/api/v1/portal/common/uploads'

export const downloadModel = `${baseURL}/预算科目模版.xlsx`
export const downloadGuide = `${baseURL}/学识云经费管理上手指南--V1.0.pdf`

/**
 * 极验初始化
 * @param {*} data
 */
export const initGeeTest = (data) => get(`/api/v1/validation/geetest`, data)

/**
  * 获取短信验证，发送短信
  * @param {*} data
  */
export const smsValidate = (data) => post(`/api/v1/validation/sms_validate`, data)

/**
 * 通用的获取短信验证码
 * @param {*} data
 */
export const commonSmsvalidate = (data) => post(`/api/v1/validation/common_sms_validate`, data)

/**
 * 仅仅用于验证码的核对
 * @param {*} data
 */
export const checkCaptcha = (data) => post(`/api/v1/validation/captcha`, data)

/**
 * 用户注册
 * @param {*} data
 */
export const register = (data) => post(`/api/v1/validation/register`, data)

/**
 * 忘记密码时检验短信验证码
 * @param {*} data
 */
export const resetPwdSmsValidate = (data) => post(`/api/v1/validation/reset_pwd`, data)

/**
 * 忘记密码时设置新密码
 * @param {*} token
 * @param {*} data
 */
export const resetPwd = (token, data) => put(`/api/v1/validation/reset_pwd/${token}`, data)

/**
 * 用户登录验证
 * @param {*} data
 */
export const login = (data) => post(`/api/v1/login`, data)

/**
 * 第三方登录 获取跳转地址
 * @param {*} oauthType oauth_type取值 【qq】【wechat】【weibo】
 */
export const thirdPartyLoginGetUrl = (oauthType, data) => get(`/api/v1/sns/authorize/${oauthType}`, data)

/**
 * 用户注销
 * @param {*} data
 */
export const signOut = (data) => get(`/api/v1/sign_out`, data)

/**
 * 激活邮箱
 * @param {*} data
 */
export const emailValidate = (data) => put(`/api/v1/validation/email_validate`, data)

/**
 * 发送激活邮件
 * @param {*} data
 */
export const sendValidateEmail = (data) => post(`/api/v1/validation/email_validate`, data)

/**
 * 获取首页展示需要的数据
 * @param {*} data
 */
export const getIndexData = (data) => get(`/api/v1/portal/index`, data)

/**
 * 获取所有模块列表
 * @param {*} data
 */
export const getAllModules = (data) => get(`/api/v1/portal/modules`, data)

/**
 * 收藏系统模块
 * @param {*} id
 * @param {*} data
 */
export const addModule = (id, data) => post(`/api/v1/portal/modules/${id}`, data)

/**
 * 删除收藏的模块
 * @param {*} id
 * @param {*} data
 */
export const deleteModule = (id, data) => remove(`/api/v1/portal/modules/${id}`, data)

/**
 * 获取账号的状态信息
 * @param {*} data
 */
export const getAccountInfo = (data) => get(`/api/v1/portal/account`, data)

/**
 * 更新用户当前登录的时间
 */
export const updateAccountLoginTime = () => put(`/api/v1/portal/account/login_at`)

/**
 * 更新头像的url
 * @param {*} data
 */
export const updateAvatar = (data) => put(`/api/v1/portal/account/avatar`, data)

/**
 * 更新用户密码
 * @param {*} data
 */
export const updatePassword = (data) => put(`/api/v1/portal/account/password`, data)

/**
 * 发送绑定邮箱的链接
 * @param {*} data
 */
export const bindEmail = (data) => post(`/api/v1/validation/email_validate`, data)

/**
 * 更新当前用户的资料信息
 * @param {*} data
 */
export const updateAccountInfo = (data) => put(`/api/v1/portal/account`, data)

/**
 * 更新用户第一此状态
 */
// export const updateAccountFirstStatus = () => put(`/api/v1/portal/account/first_status`)

/**
 * 上传图片
 * @param {*} data
 */
export const uploadFile = (data) => upload(`/api/v1/portal/common/uploads`, data)

/**
 * 更新我的履历信息
 * @param {*} data
 */
export const updateAccountRecord = (data) => put(`/api/v1_2/portal/profile`, data)

/**
 * 获取我的履历信息
 * @param {*} data
 */
export const getAccountRecord = (data) => get(`/api/v1_2/portal/profile`, data)

/*
  ============== start  控制台 ==================
*/

/**
 * 获取控制台首页数据
 */
export const getConsoleData = () => get(`/api/v1/portal/index`)

/*
  ============== end  控制台 ==================
*/

/*
  ============== start  我的任务 ==================
*/

/**
 * 添加主任务
 * @param {*} data
 */
export const tasksAddTask = (data) => post(`/api/v1_2/portal/tasks`, data)

/**
 * 添加子任务
 * @param {*} data
 */
export const tasksAddSubTask = (data) => post(`/api/v1_2/portal/subtasks`, data)

/**
 * 获取主任务列表
 * @param {*} data
 */
export const tasksGetTaskList = (data) => get(`/api/v1_2/portal/tasks`, data)

/**
 * 获取子任务列表
 * @param {*} data
 */
export const tasksGetSubTaskList = (data) => get(`/api/v1_2/portal/subtasks`, data)

/**
 * 删除主任务
 * @param {*} data
 */
export const deleteTask = (id) => remove(`/api/v1_2/portal/tasks/${id}`)

/**
 * 删除主任务
 * @param {*} data
 */
export const deleteSubTask = (id) => remove(`/api/v1_2/portal/subtasks/${id}`)

/**
 * 更新主主任务状态
 * @param {*} data
 */
export const updateTaskStatus = (data) => put(`/api/v1_2/portal/tasks/update`, data)

/**
 * 更新子主任务状态
 * @param {*} data
 */
export const updateSubTaskStatus = (data) => put(`/api/v1_2/portal/subtasks/update`, data)

/**
 * 更新主主任务信息
 * @param {*} data
 */
export const updateTask = (id, data) => put(`/api/v1_2/portal/tasks/${id}`, data)

/**
 * 更新子主任务信息
 * @param {*} data
 */
export const updateSubTask = (id, data) => put(`/api/v1_2/portal/subtasks/${id}`, data)

/*
  ============== end  我的任务 ==================
*/

/*
  ============== start 我的成果相关接口 ==================
*/
/**
 * 获取成果列表
 * @param {*} data
 */
export const getAchievementLists = (data) => get(`/api/v1_2/portal/achievement`, data)

/**
 * 获取成果详情
 * @param {*} id
 * @param {*} data
 */
export const getAchievementDetails = (id, data) => get(`/api/v1_2/portal/achievement/${id}`, data)

/**
 * 删除成果
 * @param {*} id
 * @param {*} data
 */
export const deleteAchievement = (id, data) => remove(`/api/v1_2/portal/achievement/${id}`, data)

/**
 * 新增成果
 * @param {*} data
 */
export const addAchievement = (data) => post(`/api/v1_2/portal/achievement`, data)

/**
 * 编辑成果信息
 * @param {*} id
 * @param {*} data
 */
export const updateAchievement = (id, data) => put(`/api/v1_2/portal/achievement/${id}`, data)

/**
 * 创建成果导出任务
 * @param {*} data
 */
export const createExportAchievementTask = (data) => post(`/api/v1_2/portal/achievement/export_task`, data)

/**
 * 获取成果导出状态
 * @param {*} id
 * @param {*} data
 */
export const getExportAchievementStatus = (id, data) => get(`/api/v1_2/portal/achievement/export_status/${id}`, data)

/**
 * 获取成果认领列表
 */
export const getAchievementClaimLists = () => get(`/api/v1_5/portal/achievement/claim`)

/**
 * 个人成果认领
 * @param {*} id
 * @param {*} data
 */
export const myClaimAchievement = (id, data) => post(`/api/v1_5/portal/achievement/claim/${id}`, data)

/**
 * 通过doi解析成果数据
 * @param {*} data
 */
export const parseDoi = (data) => post(`/api/v1_12/achievement/parse/doi`, data)

/**
 * 通过标准引用解析成果数据
 * @param {*} data
 */
export const parseQuote = (data) => post(`/api/v1_12/achievement/parse/quote`, data)

/*
  ============== end 我的成果相关接口 ==================
*/

/*
  ============== start 学术会议接口 ==================
*/
/**
 * 搜索会议列表
 * @param {*} data
 */
export const searchMeeting = (data) => get(`/api/v1_3/portal/meeting/search`, data)

/**
 * 获取用户搜索历史
 * @param {*} data
 */
export const getSearchHistory = (data) => get(`/api/v1_3/portal/meeting/search`, data)

/**
 * 获取城市/国家列表
 * @param {*} data
 */
export const initAddressCondition = (data) => get(`/api/v1_3/portal/meeting/addresses`, data)

/**
 * 获取会议详情
 * @param {*} id
 * @param {*} data
 */
export const getMeetingDetail = (id, data) => get(`/api/v1_3/portal/meeting/${id}`, data)

/**
 * 获取收藏会议列表
 * @param {*} data
 */
export const getFollowList = (data) => get(`/api/v1_3/portal/meeting/collect`, data)

/**
 * 收藏或取消收藏会议
 * @param {*} id
 * @param {*} data
 */
export const handleFollowMeeting = (id, data) => put(`/api/v1_3/portal/meeting/collect/${id}`, data)

/*
  ============== end 学术会议接口 ==================
*/

/*
  ============== start  项目相关接口 ==================
*/

/**
 * 创建项目
 * @param {*} data
 */
export const createProject = (data) => post(`/api/v1_4/portal/projects`, data)

/**
 * 获取项目列表
 * @param {*} data
 */
export const getProjectList = (data) => get(`/api/v1_4/portal/projects`, data)

/**
 * 获取项目信息
 * @param {*} id
 * @param {*} data
 */
export const getProjectDetail = (id, data) => get(`/api/v1_4/portal/projects/${id}`, data)

/**
 * 编辑项目信息
 * @param {*} id
 * @param {*} data
 */
export const editProjectDetail = (id, data) => put(`/api/v1_4/portal/projects/${id}`, data)

/**
 * 完结项目
 * @param {*} id
 * @param {*} data
 */
export const completeProject = (id, data) => put(`/api/v1_4/portal/projects/${id}/completed`, data)

/**
 * 删除项目
 * @param {*} id
 * @param {*} data
 */
export const deleteProject = (id, data) => remove(`/api/v1_4/portal/projects/${id}`, data)

/**
 * 获取项目成员
 * @param {*} id
 * @param {*} data
 */
export const getProjectMembers = (id, data) => get(`/api/v1_4/portal/projects/${id}/members`, data)

/**
 * 生成邀请链接
 * @param {*} projectId
 * @param {*} data
 */
export const renderInviteLink = (projectId) => post(`/api/v1_4/portal/projects/${projectId}/invite`)

/**
 * 申请加入项目
 * @param {*} id
 * @param {*} data
 */
export const applyForProject = (data) => post(`/api/v1_4/portal/projects/members/invite`, data)

/**
 * 删除项目成员
 * @param {*} projectId 项目id
 * @param {*} userId 成员id
 * @param {*} data
 */
export const removeProjectMember = (projectId, userId) => remove(`/api/v1_4/portal/projects/${projectId}/members/${userId}`)

/**
 * 编辑成员权限
 * @param {*} projectId 项目id
 * @param {*} userId 成员id
 * @param {*} data
 */
export const editMemberAuthority = (projectId, userId, data) => put(`/api/v1_4/portal/projects/${projectId}/members/${userId}`, data)

/**
 * 添加项目明细 上传模板
 * @param {*} projectId 项目id
 * @param {*} data 文件
 */
export const uploadTemplate = (projectId, data) => post(`/api/v1_4/portal/projects/${projectId}/budget`, data)

/**
 * 获取资金来源列表
 * @param {*} projectId
 * @param {*} data
 */
export const getBudgetSourceList = (projectId, data) => get(`/api/v1_4/portal/projects/${projectId}/fund_sources`, data)

/**
 * 获取预算科目列表
 * @param {*} projectId
 * @param {*} data
 */
export const getBugdetSubjecttList = (projectId, data) => get(`/api/v1_4/portal/projects/${projectId}/subjects`, data)

/**
 * 获取经费明细列表（到账，核减，开支）
 * @param {*} data
 */
export const getfundDetails = (data) => get(`/api/v1_4/portal/funds`, data)

/**
 * 到账登记
 * @param {*} data
 */
export const createAllotment = (data) => post(`/api/v1_4/portal/allotments`, data)

/**
 * 获取到账详情
 * @param {*} id
 * @param {*} data
 */
export const getAllotmentInfo = (id, data) => get(`/api/v1_4/portal/allotments/${id}`, data)

/**
 * 编辑到账详情
 * @param {*} id
 * @param {*} data
 */
export const editAllotment = (id, data) => put(`/api/v1_4/portal/allotments/${id}`, data)

/**
 * 删除一条到账记录
 * @param {*} id
 * @param {*} data
 */
export const deleteAllotment = (id, data) => remove(`/api/v1_4/portal/allotments/${id}`, data)

/**
 * 开支登记
 * @param {*} data
 */
export const createExpense = (data) => post(`/api/v1_4/portal/expenses`, data)

/**
 * 获取开支详情
 * @param {*} id
 * @param {*} data
 */
export const getExpenseInfo = (id, data) => get(`/api/v1_4/portal/expenses/${id}`, data)

/**
 * 编辑开支详情
 * @param {*} id
 * @param {*} data
 */
export const editExpense = (id, data) => put(`/api/v1_4/portal/expenses/${id}`, data)

/**
 * 获取开支审核列表
 * @param {*} data
 */
export const getExpenseList = (data) => get(`/api/v1_4/portal/expenses`, data)

/**
 * 编辑开支审核状态
 * @param {*} id
 * @param {*} data
 */
export const auditExpenseStatus = (id, data) => put(`/api/v1_4/portal/expenses/${id}/status`, data)

/**
 * 核减登记
 * @param {*} data
 */
export const createDecExpense = (data) => post(`/api/v1_4/portal/dec_expenses`, data)

/**
 * 获取核减详情
 * @param {*} id
 * @param {*} data
 */
export const getDecExpenseInfo = (id, data) => get(`/api/v1_4/portal/dec_expenses/${id}`, data)

/**
 * 编辑核减详情
 * @param {*} id
 * @param {*} data
 */
export const editDecExpense = (id, data) => put(`/api/v1_4/portal/dec_expenses/${id}`, data)

/**
 * 删除一条核减记录
 * @param {*} id
 * @param {*} data
 */
export const deleteDecExpense = (id, data) => remove(`/api/v1_4/portal/dec_expenses/${id}`, data)

/**
 * 获取经费预算
 * @param {*} id
 */
export const getProjectBudGet = (id, data) => get(`/api/v1_4/portal/projects/${id}/budget`, data)

/**
 * 编辑经费预算
 * @param {*} id
 */
export const updateProjectBudGet = (id, data) => put(`/api/v1_4/portal/projects/${id}/budget`, data)

/**
 *  获取经费进度
 * @param {*} data
 */
export const getProjectFundProgress = (data) => get(`/api/v1_4/portal/funds/progress`, data)

/**
 * 检查预算科目 可不可以被删除
 * @param {*} data
 */
export const checkBudgetSubject = (data) => post(`/api/v1_12/project/budget/subject/check`, data)

/**
 * 检查资金来源是否可以被修改和删除
 * @param {*} data
 */
export const checkBudgetSource = (data) => post(`/api/v1_12/project/budget/source/check`, data)
/*
  ============== end  项目相关接口 ==================
*/

/**
 * ========== start 项目成果相关接口 ==========
 */

/**
 * 获取可导入项目的成果列表
 * @param {*} data
 */
export const getImportableAchievementList = (data) => get(`/api/v1_5/portal/achievements`, data)

/**
 * 获取项目成果列表
 * @param {*} data
 */
export const getProjectAchievementList = (data) => get(`/api/v1_5/portal/project_achievements`, data)

/**
 * 导入成果到项目
 * @param {*} data
 */
export const importAchievementToProject = (data) => post(`/api/v1_5/portal/project_achievement`, data)

/**
 * 手动创建项目成果
 * @param {*} data
 */
export const createAchievementToProject = (data) => post(`/api/v1_5/portal/project_achievement`, data)

/**
 * 删除项目成果
 * @param {*} data
 * @param {*} id
 */
export const deleteProjectAchievement = (id, data) => remove(`/api/v1_5/portal/project_achievement/${id}`, data)

/**
 * 获取项目成果详情
 * @param {*} data
 * @param {*} id
 */
export const getProjectAchievementDetail = (id, data) => get(`/api/v1_5/portal/project_achievement/${id}`, data)

/**
 * 编辑项目成果详情
 * @param {*} data
 * @param {*} id
 */
export const editProjectAchievementDetail = (id, data) => put(`/api/v1_5/portal/project_achievement/${id}`, data)

/**
 * 创建项目成果导出任务
 * @param {*} data
 */
export const createProjectAchievementExportTask = (data) => post(`/api/v1_5/portal/project_achievement/export_task`, data)

/**
 * 认领项目成果
 * @param {*} data
 * @param {*} id
 */
export const claimAchievement = (id, data) => post(`/api/v1_5/portal/achievement/claim/${id}`, data)

/**
 * ========== end 项目成果相关接口 ==========
 */

/**
 * ========== start 消息相关接口 ==========
 */

/**
 * 获取消息列表
 * @param {*} data
 */
export const getMessageList = (data) => get(`/api/v1_6/portal/messages`, data)

/**
 * 获取未读消息条数
 * @param {*} data
 */
export const getUnreadMessageCount = (data) => get(`/api/v1_6/portal/messages/count`, data)

/**
 * 标记消息已读
 * @param {*} data
 */
export const updateMessageToRead = (data) => put(`/api/v1_6/portal/messages`, data)

/**
 * ========== end 消息成果相关接口 ==========
 */

/**
 * ========== start 团队管理 ==========
 */

/**
  * 获取
  */
// export const getUnreadMessageCount = () => get(`/api/v1_8/portal/team_index_info`)

/**
 * 用户创建团队
 * @param {*} data
 */
export const createTeam = (data) => post(`/api/v1_8/portal/team`, data)

/**
 * 获取团队的初始化信息
 * data
 */
export const getTeamInitINfo = (data) => get(`/api/v1_8/portal/team_index_info`, data)

/**
 * 根据ID获取团队信息
 * @param {*} data
 */
export const getTeamInfo = (data) => get(`/api/v1_8/portal/team/info`, data)

/**
 * 修改团队信息
 * @param {*} data
 */
export const updateTeamInfo = (id, data) => put(`/api/v1_8/portal/team/${id}`, data)

/**
 * index 获取所有的团队下拉列表
 * task 获取给当前用户派发了任务的团队列表
 * @param {*} data
 */
export const getTeamsList = (data) => get(`/api/v1_8/portal/teams/down`, data)

/**
 * 获取团队项目列表
 * @param {*} data
 */
export const getTeamsProjectList = (data) => get(`/api/v1_8/portal/team/projects`, data)

/**
 * 获取团队项目下拉列表
 * @param {*} data
 */
export const getTeamProjectDown = (data) => get(`/api/v1_8/portal/team/projects/down`, data)

/**
 * 添加团队成员到项目
 * @param {*} data
 */
export const addMemberTeamProject = (data) => post(`/api/v1_8/portal/team/member/join_project`, data)

/**
 * 获取邀请成员信息
 * @param {*} data
 */
export const getTeamsAddMemberInfo = (data) => get(`/api/v1_8/portal/team/member/invite`, data)

/**
 * 用户申请加入团队
 * @param {*} data
 */
export const addTeam = (data) => post(`/api/v1_8/portal/team/member/invite`, data)

/**
 * 获取团队成员列表 如果需要搜索加上 action=search
 * @param {*} data
 */
export const getTeamMmbers = (data) => get(`/api/v1_8/portal/team/members`, data)

/**
 * 编辑成员信息
 * @param {*} id
 * @param {*} data
 */
export const updateTeamMmbers = (id, data) => put(`/api/v1_8/portal/team/member/${id}`, data)

/**
 * 删除团队成员
 * @param {*} id
 */
export const deleteTeamMmber = (id, data) => remove(`/api/v1_8/portal/team/member/${id}`, data)

/**
 * 获取团队成员的成果列表
 * @param {*} id
 * @param {*} data
 */
export const getTeamMmberAchievements = (id, data) => get(`/api/v1_8/portal/team/member/${id}/achievements`, data)

/**
 * 获取团队经费信息
 * @param {*} data
 */
export const getTeamFund = (data) => get(`/api/v1_8/portal/team/funds`, data)

/**
 * 管理员获取任务列表
 * @param {*} data
 */
export const getTeamTasks = (data) => get(`/api/v1_8/portal/team/tasks`, data)

/**
 * 成员获取主任务列表
 * @param {*} data
 */
export const getTeamTasksMember = (data) => get(`/api/v1_8/portal/team/tasks/member`, data)

/**
 * 发布一个任务
 * @param {*} data
 */
export const addTeamTask = (data) => post(`/api/v1_8/portal/team/task`, data)

/**
 * 管理员更新主任务详情 或者状态
 * @param {*} id
 * @param {*} data
 */
export const updateMainTask = (id, data) => put(`/api/v1_8/portal/team/task/${id}`, data)

/**
 * 更改子任务详情 或者 状态
 * @param {*} id
 * @param {*} data
 */
export const updateTeamSubTask = (id, data) => put(`/api/v1_8/portal/team/sub_task/${id}`, data)

/**
 * 获取团队子任务列表
 * @param {*} id
 * @param {*} data
 */
export const getTeamSubTask = (id, data) => get(`/api/v1_8/portal/team/sub_task/${id}`, data)

/**
 * 获取用户在团队成果登记中要导入成果列表
 */
export const getTeamImportAchievement = (data) => get(`/api/v1_8/portal/team/achievements/import`, data)

/**
 * 批量导入成果列表
 */
export const importTeamAchievements = (data) => post(`/api/v1_8/portal/team/achievement?action=import`, data)

/**
 * 获取成果统计信息
 * @param {*} data
 */
export const getTeamAchievementCount = (data) => get(`/api/v1_8/portal/team/achievements?action=statistics`, data)

/**
 * 添加团队成果信息
 * @param {*} data
 */
export const addTeamAchievement = (data) => post(`/api/v1_8/portal/team/achievement?action=submit`, data)

/**
 * 获取团队成果列表
 * @param {*} data
 */
export const getTeamAchievementList = (data) => get(`/api/v1_8/portal/team/achievements`, data)

/**
 * 团队成果创建下载任务
 * @param {*} data
 */
export const createTeamAchievementExportTask = (data) => post(`/api/v1_8/portal/team/achievement/export`, data)

/**
 * 删除团队成果信息
 * @param {*} id
 * @param {*} data
 */
export const deleteTeamAchievement = (id, data) => remove(`/api/v1_8/portal/team/achievement/${id}`, data)

/**
 * ========== end 团队管理 ==========
 */

/**
 * ========== start 手机端 ==========
 */

/**
 * 用户登录
 * @param {*} data
 */
export const Mlogin = (data) => post(`/mapi/v1/login`, data)

/**
 * 用户注册
 * @param {*} data
 */
export const Mregister = (data) => post(`/mapi/v1/validation/register`, data)

/**
  * 获取短信验证，发送短信
  * @param {*} data
  */
export const MgetSmsCode = (data) => post(`/mapi/v1/validation/sms_validate`, data)

/**
 * 忘记密码时检验短信验证码
 * @param {*} data
 */
export const MresetPwdSmsValidate = (data) => post(`/mapi/v1/validation/reset_pwd`, data)

/**
 * 忘记密码时设置新密码
 * @param {*} token
 * @param {*} data
 */
export const MresetPwd = (token, data) => put(`/mapi/v1/validation/reset_pwd/${token}`, data)

/**
 * 用户申请加入团队
 * @param {*} data
 */
export const MaddTeam = (data) => post(`/api/v1_8/portal/team/member/invite`, data)

/**
 * ========== end 手机端 ==========
 */

/*
  ============== start  数据服务 ==================
*/

/**
 * 创建订单
 * @param {*} data
 */
export const createOrder = (data) => post(`/api/v1_9/portal/ds_order`, data)

/**
 * 获取订单列表
 * @param {*} data
 */
export const getOrderList = (data) => get(`/api/v1_9/portal/ds_orders`, data)

/**
 * 更改订单详情
 * @param {*} id
 * @param {*} data
 */
export const updateOrderDetails = (id, data) => put(`/api/v1_9/portal/ds_order/${id}`, data)

/*
  ============== end  数据服务 ==================
*/

/*
  ============== start  用户统计 ==================
*/

/**
 * 用户操作行为统计
 * @param {*} data
 */
export const userHandle = (data) => post(`/api/v1_9/logs?action=uoper`, data)

/*
  ============== end  用户统计 ==================
*/

/*
  ============== start  企业模块 ==================
*/

/**
 * 获取各类下拉列表
 */
export const getDownList = () => get(`/api/v1_10/enterprise/down`)

/**
 * 获取用户在此企业中的信息 （初始化信息）
 * @param {*} data
 */
export const getCompanyUserInfo = (data) => get(`/api/v1_10/enterprise/user_info`, data)

/**
 * 创建企业信息
 * @param {*} data
 */
export const createCompany = (data) => post(`/api/v1_10/enterprise`, data)

/**
 * 切换企业信息
 * @param {*} id
 */
export const changeCompany = (id) => put(`/api/v1_10/enterprise/${id}/switch`)

/**
 * 管理员获取首页信息
 * @param {*} data
 */
export const managerGetIndexData = (data) => get(`/api/v1_10/enterprise/index?role=manager`, data)

/**
 * 成员获取首页信息
 * @param {*} data
 */
export const memberGetIndexData = (data) => get(`/api/v1_10/enterprise/index?role=member`, data)

/**
 * 获取企业项目列表
 * @param {*} data
 */
export const getCompanyProjectList = (data) => get(`/api/v1_10/enterprise/project`, data)

/**
 * 获取项目下拉列表
 * @param {*} data
 */
export const getCompanyProjectDownList = (data) => get(`/api/v1_10/enterprise/project/down`, data)

/**
 * 添加新的企业项目
 * @param {*} data
 */
export const addCompanyProject = (data) => post(`/api/v1_10/enterprise/project`, data)

/**
 * 导入个人项目/成果
 * @param {*} data
 */
export const importCompanyProject = (data) => post(`/api/v1_10/enterprise/project/import`, data)

/**
 * 删除项目信息
 * @param {*} id
 * @param {*} data
 */
export const deleteCompanyProject = (id, data) => remove(`/api/v1_10/enterprise/project/${id}`, data)

/**
 * 获取导入项目列表
 * @param {*} data
 */
export const getImportProjectList = (data) => get(`/api/v1_10/enterprise/project/import`, data)

/**
 * 更改科技项目
 * 【该接口只有项目的负责人才能更改项目的信息/企业管理员不能调用该接口】 【提交字段跟出创建项目信息一样， 传哪些字段更改哪些字段】
 * @param {*} data
 */
export const updateCompanyProject = (id, data) => put(`/api/v1_10/enterprise/project/${id}`, data)

/**
 * 获取知识产权列表
 * @param {*} data
 */
export const getIprList = (data) => get(`/api/v1_10/enterprise/achievement`, data)

/**
 * 获取知识产权转化列表
 * @param {*} data
 */
export const getIprTransformList = (data) => get(`/api/v1_10/enterprise/achievement/income`, data)

/**
 * 获取知识产权下拉列表
 * @param {*} data
 */
export const getIprDownList = (data) => get(`/api/v1_10/enterprise/achievement/down`, data)

/**
 * 删除知识产权
 * @param {*} id
 * @param {*} data
 */
export const deleteIpr = (id, data) => remove(`/api/v1_10/enterprise/achievement/${id}`, data)

/**
 * 添加知识产权信息
 * @param {*} data
 */
export const addIpr = (data) => post(`/api/v1_10/enterprise/achievement`, data)

/**
 * 更新知识产权信息
 * @param {*} id
 * @param {*} data
 */
export const updateIpr = (id, data) => put(`/api/v1_10/enterprise/achievement/${id}`, data)

/**
 * 获取营收情况
 * @param {*} data
 */
export const getRevenueList = (data) => get(`/api/v1_10/enterprise/revenue`, data)

/**
 * 删除营收情况记录
 * @param {*} id
 * @param {*} data
 */
export const deleteRevenue = (id, data) => remove(`/api/v1_10/enterprise/revenue/${id}`, data)

/**
 * 添加营收记录
 * @param {*} data
 */
export const addRevenue = (data) => post(`/api/v1_10/enterprise/revenue`, data)

/**
 * 编辑营收记录详情
 * @param {*} id
 * @param {*} data
 */
export const updateRevenue = (id, data) => put(`/api/v1_10/enterprise/revenue/${id}`, data)

/**
 * 获取支出情况列表
 * @param {*} data
 */
export const getExpendList = (data) => get(`/api/v1_10/enterprise/allotment`, data)

/**
 * 删除支出记录
 * @param {*} id
 * @param {*} data
 */
export const deleteExpend = (id, data) => remove(`/api/v1_10/enterprise/allotment/${id}`, data)

/**
 * 添加支出记录
 * @param {*} data
 */
export const addExpend = (data) => post(`/api/v1_10/enterprise/allotment`, data)

/**
 * 更改支出记录信息
 * @param {*} id
 * @param {*} data
 */
export const updateExpend = (id, data) => put(`/api/v1_10/enterprise/allotment/${id}`, data)

/**
 * 获取企业列表
 *  -加入的
 *  -创建的
 * @param {*} data
 */
export const getCompanyList = (data) => get(`/api/v1_10/enterprise`, data)

/**
 * 获取企业详情
 * @param {*} id
 */
export const getCompanyDetails = (id) => get(`/api/v1_10/enterprise/${id}`)

/**
 * 编辑企业基本信息
 * @param {*} id
 * @param {*} data
 */
export const updateCompanyDetails = (id, data) => put(`/api/v1_10/enterprise/${id}`, data)

/**
 * 获取企业成员列表
 * @param {*} data
 */
export const getCompanyMemberList = (data) => get(`/api/v1_10/enterprise/member`, data)

/**
 * 删除成员
 * @param {*} id
 * @param {*} data
 */
export const deleteCompanyMember = (id, data) => remove(`/api/v1_10/enterprise/member/${id}`, data)

/**
 * 获取邀请成员的邀请链接
 * @param {*} data
 */
export const getAddCompanyMemberInviteLink = (data) => get(`/api/v1_10/enterprise/meb_invite`, data)

/**
 * 成员加入企业
 * @param {*} data
 */
export const addCompanyMember = (data) => post(`/api/v1_10/enterprise/member/invite`, data)

/**
 * 管理员把自己的管理权限进行移交
 * @param {*} id
 * @param {*} data
 */
export const updateMemberRole = (id, data) => put(`/api/v1_10/enterprise/member/${id}/permiss`, data)

/*
  ============== end  企业模块 ==================
*/

/*
  ============== start  期刊嵌入接口 ==================
*/

/**
 * 获取用户绑定信息
 * @param {*} data
 */
export const getIJournalBindStatus = (data) => get(`/api/v1_13/openapi/bind/info`, data)

/**
 * 一键登录iJournal
 * @param {*} data
 */
export const iJournalLogin = (data) => post(`/api/v1_13/openapi/login/ijournal`, data)

/**
 * 绑定iJournal账号
 * @param {*} data
 */
export const iJournalBind = (data) => post(`/api/v1_13/openapi/bind/ijournal`, data)

/**
 * 获取首页期刊列表
 * @param {*} data
 */
export const getJournalList = (data) => get(`/api/v1_13/openapi/journal/topList`, data)

/*
  ============== end  期刊嵌入接口 ==================
*/



// WEBPACK FOOTER //
// ./src/api/index.js